<lib-topbar-switcher id="appTopBar" [sponsorImage]="sponsorImage" [topbarLabellist]="topbarLabellist"
    [loginRegisterText]="loginRegisterText" [langSelection]="currentPageLangSelection"
    [profileMenuItems]="profileMenuItems" [showLoginRegisterLogoutButton]="showLoginRegisterLogoutButton" [hideAuthenticationForCustomerIdentification]="hideAuthenticationForCustomerIdentification"
    (navigateToNavLink)="navigateToNavLink($event)">
</lib-topbar-switcher>